import { AxiosResponse } from "axios";
import * as ApiUrls from "./ApiUrl.Report";
import { EEReportGeneration, EEReportTable } from "../../Model/Dto/EmploymentEquity/Reporting";
import { axiosInstance } from "../AxiosInterceptor";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import { SearchResult } from "../../Model/Dto/SearchResult";
import { ReportGeneration } from "../../Model/Dto/EmploymentEquity/Reporting";

export const EEReportService = {
    GenerateReport: (request: EEReportGeneration.Request): Promise<AxiosResponse<any>> => axiosInstance.post(`${ApiUrls.GenerateReport}`, request),
    searchReport: (request: EEReportTable.SearchRequest): Promise<AxiosResponse<EEReportTable.SearchResponse>> => axiosInstance.post(`${ApiUrls.SearchReport}`, request),
    deleteReport: (id: number): Promise<AxiosResponse<any>> => axiosInstance.delete(`${ApiUrls.deleteReport}?documentId=${id}`),
    downloadReport: (documentId: string, scorecardId: string): Promise<AxiosResponse<any>> => axiosInstance.get(`${ApiUrls.downloadReport}?documentId=${documentId}&scorecardId=${scorecardId}`),
    
    GetLatestPublishedReport: (scorecardId: string): Promise<AxiosResponse<SearchResult<ReportGeneration.ReportGenerationResult>>> =>
        axiosCoreInstance.get(`${ApiUrls.GetLatestPublishedReport}${scorecardId}`),
    
    GetDocumentUrl: (id: number): Promise<AxiosResponse<string>> => axiosCoreInstance.get(`${ApiUrls.GetDocumentUrl}${id}`),

    GenerateEEAReport: (request: EEReportGeneration.Request): Promise<AxiosResponse<any>> => 
        axiosCoreInstance.post(`${ApiUrls.GenerateEEAReport}`, request)
}

